import { NO_ELEMENT, rm } from 'utils';
import { StarRating } from 'components/Shared/StarRating';
import connect from 'components/Shared/connect';
import { getTotalNumberOfReviews, getAverageReviewScore } from 'views/ProductPage/selector';
import cn from 'classnames';
import styles from './reviewStats.scss';

const getReviewText = (amountOfReviews: number) => {
  if (!amountOfReviews) {
    return NO_ELEMENT;
  }

  if (amountOfReviews > 1) {
    return rm('product_nbrofreviews', amountOfReviews);
  }

  return rm('product_singlereview');
};

interface ReviewStatProps {
  score: number;
  amountOfReviews: number;
  starRatingClassName?: string;
  starRatingContainerClassName?: string;
  amountOfReviewsClassName?: string;
}

const _ReviewStats = ({
  score,
  amountOfReviews,
  starRatingClassName,
  starRatingContainerClassName,
  amountOfReviewsClassName
}: ReviewStatProps) => {
  return (
    <>
      <StarRating
        containerClassName={cn(styles.starRatingContainer, starRatingContainerClassName)}
        className={starRatingClassName}
        score={score}
      />
      <p className={cn(amountOfReviewsClassName, styles.amountOfReviews)}>
        {getReviewText(amountOfReviews)}
      </p>
    </>
  );
};

export const ReviewStats = connect(state => ({
  score: getAverageReviewScore(state),
  amountOfReviews: getTotalNumberOfReviews(state)
}))(_ReviewStats);

interface MobileReviewStatsProps {
  className?: string;
}
export const MobileReviewStats = ({ className }: MobileReviewStatsProps) => {
  return (
    <span className={cn(styles.accordionReviewsContainer, className)}>
      <ReviewStats
        starRatingContainerClassName={styles.starRatingContainerMargin}
        starRatingClassName={styles.starSize}
      />
    </span>
  );
};

type DrawerReviewStatsProps = ReviewStatProps & MobileReviewStatsProps;
export const DrawerReviewStats = ({ className, ...props }: DrawerReviewStatsProps) => (
  <span className={cn(styles.accordionReviewsContainer, className)}>
    <_ReviewStats
      starRatingContainerClassName={styles.starRatingContainerMargin}
      starRatingClassName={styles.starSize}
      {...props}
    />
  </span>
);
